module.exports = __webpack_public_path__ + "img/neos-logo.3e448eb7.svg";